import request from '@/utils/axios'

export function getBanners (params) {
  return request({
    url: '/api/promote',
    methods: 'get',
    params: params
  })
}
